import { Typography } from '@/components/UI/Typography'
import type { FC } from 'react'

type Props = {
  /** ポイント履歴のラベル（例: スタンプ獲得（渡月橋）） */
  label: string
  /** ポイント数（正: 獲得, 負: 使用）。未指定のとき pt 列を表示しない（ポイントカードの獲得履歴用・#2970） */
  point?: number
  /** 取得日（例: 2026-03-10） */
  acquiredAt: string
  /** 指定時はラベルがタップ可能（下線付き button）になる。未指定時は下線なしの通常テキスト（#2972） */
  onClick?: () => void
}

/** ポイント履歴の1行コンポーネント */
export const PointHistoryItem: FC<Props> = ({ label, point, acquiredAt, onClick }) => {
  const isPositive = (point ?? 0) >= 0

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex-1 min-w-0 mr-3">
          {onClick ? (
            // ラベル文字列そのものがアクセシブルネームになるため aria-label は付けない
            <button type="button" onClick={onClick} className="block w-full max-w-full bg-transparent p-0 text-left">
              <Typography variant="caption1" component="span" className="block truncate underline">
                {label}
              </Typography>
            </button>
          ) : (
            <Typography variant="caption1" component="p" className="truncate">
              {label}
            </Typography>
          )}
          <Typography variant="caption1" component="p">
            {acquiredAt}
          </Typography>
        </div>
        {point !== undefined && (
          <p
            className="font-bold text-[20px] leading-[32px] whitespace-nowrap"
            style={{ color: isPositive ? '#000000' : '#d46a6a' }}
          >
            {point}pt
          </p>
        )}
      </div>
      <div className="h-px bg-gray-200 w-full" />
    </div>
  )
}
